import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPageLock"><Path d="M4 22V2H20V11.9996C19.1643 11.3719 18.1256 11 17 11C14.9497 11 13.1876 12.2341 12.416 14H11V22H4Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 16V22H13V16H14C14 14.3431 15.3431 13 17 13C18.6569 13 20 14.3431 20 16H21ZM19 18H15V20H19V18ZM18 16C18 15.4477 17.5523 15 17 15C16.4477 15 16 15.4477 16 16H18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageLock;
